<template>
  <div class="geofence-popup-editor p-1 px-2">
    <div v-if="!isEditing">
      <div class="d-flex gap-2 align-items-center" v-if="item.geo_type.type === 'polygon'">
        <b-button variant="dark" size="sm" @click="startEdit" v-b-tooltip.hover="$gettextInterpolate($gettext('Edit Shape: %{name}'), { name: item.name || $gettext('Unnamed') })">
          <font-awesome-icon icon="draw-polygon" />
        </b-button>
        <b-button variant="dark" size="sm" :to="{name: 'GeofencesEdit', params: { id: item.id }}" target="_blank" v-b-tooltip.hover="$gettextInterpolate($gettext('Edit Element: %{name}'), { name: item.name || $gettext('Unnamed') })">
          <font-awesome-icon icon="edit" />
        </b-button>
        <b-button size="sm" variant="danger" v-b-tooltip.hover="$gettext('Completely DELETE this Element and its Relations')" @click="emitDelete()">
          <font-awesome-icon icon="trash-alt" />
        </b-button>
      </div>
      <div class="d-flex gap-2 align-items-center" v-else>
        <b-button size="sm" variant="dark" @click="startEdit" v-b-tooltip.hover="$gettextInterpolate($gettext('Edit Element: %{name}'), { name: item.name || $gettext('Unnamed') })">
          <font-awesome-icon icon="edit" />
        </b-button>
        <b-button size="sm" variant="danger" v-b-tooltip.hover="$gettext('Completely DELETE this Element and its Relations')" @click="emitDelete()">
          <font-awesome-icon icon="trash-alt" />
        </b-button>
      </div>
    </div>

    <div v-else class="d-flex align-items-center gap-2 p-0">
      <b-button variant="success" size="sm" @click="saveEdit" v-b-tooltip.hover="$gettext('Save Element')">
        <font-awesome-icon icon="check" />
      </b-button>
      <b-button variant="danger" size="sm" @click="cancelEdit" v-b-tooltip.hover="$gettext('Cancel Edit')">
        <font-awesome-icon icon="ban" />
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['cancel-edit', 'delete', 'save-edit', 'start-edit'],
  name: 'GeofenceMapPopupEditor',
  props: {
    item: {
      type: Object,
      required: true
    },
    // We pass the leaflet layer as a prop too if we want direct access,
    // but better to emit events to the parent (MapService or Page)
    layer: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isEditing: false
    }
  },
  created() {
    // Sync with layer edit state if available
    if (this.layer && typeof this.layer.editEnabled === 'function') {
      this.isEditing = this.layer.editEnabled()
    }
  },
  methods: {
    startEdit() {
      this.isEditing = true
      this.$emit('start-edit', { item: this.item, layer: this.layer })
    },
    saveEdit() {
      this.$emit('save-edit', { item: this.item, layer: this.layer })
      this.isEditing = false
    },
    cancelEdit() {
      this.$emit('cancel-edit', { item: this.item, layer: this.layer })
      this.isEditing = false
    },
    emitDelete() {
      if (confirm(this.$gettext('Are you sure you want to COMPLETELY DELETE THIS ELEMENT AND ITS RELATIONS?\nWARNING: THIS ACTION CANNOT BE UNDONE!'))) {
        this.$emit('delete', { item: this.item, layer: this.layer })
      }
    }
  }
}
</script>
